import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  box: {
    display: 'flex',
    justifyContent: 'center',
    height: 290,
    marginTop: -88,
  },
  cloudSelectorWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  cloudSelectorWidthHeight: { height: theme.spacing(5.5) },
}))
